import { observer } from 'mobx-react-lite';
import { FrPageBody } from '../../fr-page-layout/fr-page-body';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { frBoloPageTabConfig, FrBoloPageTab } from '../configuration/fr-bolo-tab-configuration';
import { FrBoloPageTabs } from './tabs/fr-bolo-page-tabs';
import { useBoloPanelMetadata } from '../../bolos/bolo-panel/state/bolo-panel-metadata-context';
import { cssVar, Center, Spinner, Flex, Box } from '@cad-arc';

export const FrBoloPageBody = observer(() => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState<FrBoloPageTab>(() => {
        return location.state?.activeTab || 'BOLO_DETAILS';
    });
    const loading = !useBoloPanelMetadata()?.boloId;
    const TabComponent = activeTab ? frBoloPageTabConfig[activeTab].component : undefined;

    useEffect(() => {
        const stateActiveTab = location.state?.activeTab;
        if (stateActiveTab) {
            setActiveTab(stateActiveTab);
        }
    }, [location.state?.activeTab]);

    if (loading) {
        return (
            <Center w="100%" h="100%">
                <Spinner />
            </Center>
        );
    }

    return (
        <FrPageBody customStyles={{ backgroundColor: cssVar('arc.colors.surface.foreground') }}>
            <Flex direction="column" height="100%">
                <FrBoloPageTabs onChangeTab={setActiveTab} activeTab={activeTab} />
                <Box flex={1} minHeight={0}>
                    {!!TabComponent && <TabComponent />}
                </Box>
            </Flex>
        </FrPageBody>
    );
});
